export const ATTRIBUTE_OPTIONS = [
  { value: "need", label: "Need Rank", unit: "$", type: "range" },
  { value: "academicrank", label: "Academic Rank", unit: "", type: "rank" },
];
